import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/_services/storage.service';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { ColumnItem } from 'src/app/_models/column-item.model';

@Injectable({
  providedIn: 'root'
})
export class CsvdownloadService {

  constructor(private storageService: StorageService, private translationService: LanguageManagerService) { }

    downloadFile(data, filename = 'data', language, dueDate, columnConfig) {
        let disputeColumnConfiguration: ColumnItem[] = this.storageService.get(
            columnConfig
        );
        let headers: string[]=[]
        let fields: string[]=[]
        if (!disputeColumnConfiguration) {
            //Encabezados por defecto
            headers = [
                this.translationService.translate('DCO.OperationStatement_ExpedientNumber') ,
                this.translationService.translate('DCO.OperationStatement_DisputeDate') ,
                this.translationService.translate('DCO.ClaimsClient_CommerceNumber') ,
                this.translationService.translate('DCO.ClaimsClient_CommerceName') ,
                this.translationService.translate('DCO.ClaimsClient_StateName') ,
                this.translationService.translate('DCO.OperationStatement_DisputeReason') ,
                this.translationService.translate('DCO.ClaimsClient_CardBrand') ,
                this.translationService.translate('DCO.ClaimsClient_Card') ,
                this.translationService.translate('DCO.OperationStatement_Amount') ,
                this.translationService.translate('DCO.OperationStatement_DateLimit') ,
                this.translationService.translate('DCO.OperationStatement_LastStatusDate') ,
                this.translationService.translate('DCO.ClaimsClient_AuthorizationNumber'),
                this.translationService.translate('DCO.ClaimsClient_Arn') ,
                this.translationService.translate('DCO.OperationStatement_p37')
            ];

            fields = [
                'claimOperationID',
                'doc',
                'commerceNumber',
                'commerceName',
                'groupStateName',
                'subReasonName',
                'CardBrand',
                'card',
                'amount',
                'dateLimit',
                'lastStatusChange',
                'claimOperation_Authorization',
                'arn',
                'operations_P37'
            ];
        } else {

            headers = disputeColumnConfiguration.map(
                column => this.translationService.translate(column.name)
            );
            fields = disputeColumnConfiguration.map(
                column => column.id
            );
        }

/*         if(language === 'es-ES'){
            headers = headersES;
        } else if (language === 'en-GB'){
            headers = headersEN;
        } */

        if (!dueDate) {
            // Remplazar 'expirationDate' por 'lastStatusChange' en campos y encabezados
            const index = fields.indexOf('expirationDate');
            if (index !== -1) {
                fields[index] = 'lastStatusChange';
            }

            if (language === 'es-ES') {
                headers[index] = 'Último cambio de estado';
            } else if (language === 'en-GB') {
                headers[index] = 'Last Status Change';
            }
        }

        // Convertir a CSV con solo los datos y encabezados específicos
        let csvData = this.convertToCSV(data, fields, headers);

        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    convertToCSV(objArray, fields, headers) {
        let array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = headers.join(';') + '\r\n';

        const fieldsToTranslate = ['subReasonName','stateName','groupStateName'];

        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let j = 0; j < fields.length; j++) {
                let field = fields[j];
                let value = '';
                if (field == 'CardBrand') {
                    value = this.translationService.translate("@@DCO.paymentscheme_" + array[i]['paymentScheme']) + ' ' + this.translationService.translate("@@DCO.compensation_" + array[i]['compensation']);
                } else {
                    value = array[i][field] || '';
                }

                if ((field === 'doc' && value) || (field === 'dateLimit' && value) || (field === 'lastStatusChange' && value)) {
                    const dateObj = new Date(value);

                    // Validamos que el string de fecha sea válido antes de transformarlo
                    if (!isNaN(dateObj.getTime())) {
                        const day = String(dateObj.getDate()).padStart(2, '0');
                        const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
                        const year = dateObj.getFullYear();

                        const formattedDate = `${day}/${month}/${year}`;

                        // Encapsulamos con ="..." para forzar a Excel a leerlo como texto literal DD/MM/AAAA
                        value = `${formattedDate}`;
                    }
                }

                if (field === 'arn' || field === 'operations_P37') {
                    if (value) {
                        value = `\t${value}`;
                    }
                }

                if (field === 'amount') {
                  if (value !== '' && value !== null && value !== undefined) {
                      value = "" + value;
                      value = value.replace('.', ',');
                  }
                }

                if(field ==='groupStateName'){
                    value='@@DCO.DisputeStatus_'+value
                }

                if (fieldsToTranslate.includes(field)) {
                    value = this.translationService.translate(value);
                }

                line += (line ? ';' : '') + value; // Agregar dato o vacío
            }
            str += line + '\r\n';
        }
        return str;
    }

}
